export default "__VITE_ASSET__Jym2wqib__"